import React, { useState, useRef, useEffect } from "react";
import MRMSLogo from "../../../src/assets/Images/LoginImages/MRMSLogo.png";
import PoweredBy from '../../../src/assets/Images/LoginImages/PoweredBy.png';
import { useNavigate, useSearchParams } from "react-router-dom";
import { addLoginResponse } from "../../features/login/loginSlice";
import { useDispatch } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity";
import PersistStorage from '../../utils/helpers/PersistStorage';
import CommonFunctions from "../../utils/helpers/CommonFunctions";

const LoginAuto = () => {

    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [Message, setMessage] = useState("");
    let _username = searchParams.get("u");
    let _password = searchParams.get("p");
    let _ext = searchParams.get("ext");
    let _station = searchParams.get("station");
    let _vMethod = searchParams.get("method");
    let _applicationsessionid = searchParams.get("applicationsessionid");
    let _useriplist = searchParams.get("useriplist");
    let _route = searchParams.get("rpgname");
    let _AffID = searchParams.get("affID");
    //Form values
    const [login, setLogin] = useState({vUserName: _username, vPassword: _password, vExtension: _ext, errorMsg: '', vStation: _station, vMethod: _vMethod, vApplicationSessionID: _applicationsessionid, vUserIPList: _useriplist, vRoute: _route, iAffID: _AffID, isLogin: false});
    const navigate = useNavigate();

    const InitiateLogin = async () => {
        setLogin({ ...login, errorMsg: "", isLogin: false }); 
        if(!login.vUserName || !login.vPassword)
        {
            setMessage("Auto login failed due to missing parameters. Please contact backoffice.");
        }
        else
        {
            const userIPResponse = await APICom.fetchData("full", 'https://api.ipify.org?format=json', "get", {}, {});
            let userIP = "";
            if(userIPResponse && userIPResponse.error === '')
            {
                if(userIPResponse.data.ip && userIPResponse.data.ip.length > 0)
                {
                    userIP = userIPResponse.data.ip;
                }
                else
                {
                    userIP = "50.204.237.2";
                }
            }
            else
            {
                userIP = "50.204.237.2";
            }

            const data = {
                "vUserName": login.vUserName,
                "vPassword": login.vPassword,
                "vStation": String(userIP)+"/"+String(userIP),
                "vMethod": "MRMS-MRMSDispatchAutoLogin",
                "vApplicationSessionID": "WebMRMS-chrome_114-Windows@Time_21/7/2023 @ 16:42:55",
                "vExtension": login.vExtension === ""? 1:login.vExtension,
                "vUserIPList":String(userIP)
            }
            try
            {
                const response = await APICom.fetchData("main", "AuthActions/GetUserValidation", "post", {}, data);
                if (response.error !== "") {
                    setMessage(response.error);
                }
                else if(response.data[0].hasOwnProperty("MSG"))
                {
                    setMessage(response.data[0].MSG);
                }
                else
                {
                    if(response.data[0].IsPowerUser === true){
                        await ModuleSecurity.PowerUserModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    else {
                        await ModuleSecurity.FetchAndSaveUserAssignedModules(response.data[0].iUserID, response.data[0].recordID);
                    }
                    setLogin({ ...login, errorMsg:'', isLogin: true });
                    response.data[0].BuildManifestDispatchID=false;
                    dispatch(addLoginResponse(response.data[0]));
                    await CommonFunctions.PopulateGridColorData(response.data[0].iUserAffiliateID, dispatch)
                    if(login.vRoute === "CallAgent")
                    {
                        PersistStorage.save("affSelectedCallAgent", login.iAffID, 999, true);
                        navigate('/CallAgent');
                    }
                    else
                    {
                        navigate('/Dispatch');
                    }

                }    
            }catch(e)
            {
                console.log(e);
            }
            
        }
    }
    useEffect(() => {
        try{
            const clearCacheData = () => {
                try{
                    if ('caches' in window) {
                        caches.keys().then(cacheNames => {
                            cacheNames.forEach(cacheName => {
                                caches.delete(cacheName); // Deletes each cache
                            });
                        });
                    }
                    // console.log("Complete Cache Cleared");
                }
                catch(err) {console.log(err);}
            };        
            const clearCookies = () => {
                try{
                    const cookies = document.cookie.split(";");
            
                    cookies.forEach((cookie) => {
                        const eqPos = cookie.indexOf("=");
                        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                    });
                }
                catch(err){console.log(err);}
            };
            function clearLocalStorageExcept(exceptKey) {
                try{
                    // Store the value of the key you want to retain
                    const retainedValue = localStorage.getItem(exceptKey);
                
                    // Clear all localStorage data
                    localStorage.clear();
                
                    // Restore the retained key-value pair
                    if (retainedValue !== null) {
                        localStorage.setItem(exceptKey, retainedValue);
                    }
                }
                catch(err){console.log(err);}
            };
            clearLocalStorageExcept("persist:configurationSlice"); // Clears all data from localStorage (except Important Cached Data)
            sessionStorage.clear(); // Clears all data from sessionStorage
            clearCacheData();
            clearCookies();
            InitiateLogin();
        }
        catch(err){console.log(err); InitiateLogin();}
        
    }, []);

    if (!login.isLogin)
    {

        return(
            <div>{Message}</div>
        )
    }
    else{
        return(
            <div>{Message}</div>
        )
    }

};


export default LoginAuto;